'use client'
import errImage from '@/assets/images/error-images/statsNotAvailable.svg'
import MyImage from '@/shared/components/myImage'
import { useEffect } from 'react'

export default function ErrorComponent() {
  useEffect(() => {
    try {
      const theme = window.localStorage.getItem('cb-theme') || ''
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      const metaThemeColor = document.querySelector('meta[name=theme-color]')
      const isDark = theme === 'dark' || (!theme && prefersDark)

      document.documentElement.setAttribute('data-light-mode', isDark ? 'false' : 'true')
      if (!theme) {
        window.localStorage.setItem('cb-theme', isDark ? 'dark' : 'light')
      }
      if (metaThemeColor) {
        metaThemeColor.setAttribute('content', isDark ? '#080c0f' : '#F8F8F8')
      }
    } catch (e) {
      console.error('Error setting theme:', e)
    }
  }, [])

  return (
    <div className="w-full h-[calc(100vh_-_300px)] px-4 my-4 flex items-center flex-col justify-center">
      <p className="text-2xl mb-6 px-4 text-center">
        Our team is working on the issue, please check in a while
      </p>
      <MyImage src={errImage} height={200} />
      <button onClick={() => location.reload()} className="btn-primary my-8">
        Try again
      </button>
    </div>
  )
}
